import { ReactElement, useState } from "react";

import { Box, CircularProgress } from "@mui/material";

import PictureDialog from "components/Dialog/PictureDialog";
import useValidImages from "hooks/useValidImages";

import FileCell from "./FileCell";
import PictureCell from "./PictureCell";

interface IUploadValue {
  upload_id?: string;
  url?: string;
  source_type?: string;
}

export interface IUploadCellProps {
  value?: IUploadValue;
  width?: string | number;
  height?: string | number;
}

const UploadCell = ({
  value,
  width,
  height,
}: IUploadCellProps): ReactElement | null => {
  const [pictureURL, setPictureURL] = useState<string | null>(null);

  const url = value?.url;

  const candidates = url ? [{ url }] : [];
  const { validImages, isLoading } = useValidImages(candidates);
  const isImage = validImages.length > 0;

  if (!url) {
    return null;
  }

  if (isLoading) {
    return (
      <Box
        width={width ?? "50px"}
        height={height ?? "40px"}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <CircularProgress size={20} />
      </Box>
    );
  }

  if (isImage) {
    return (
      <>
        <PictureCell
          link={url}
          onClick={() => setPictureURL(url)}
          width={width}
          height={height}
        />
        {pictureURL && (
          <PictureDialog
            open
            url={pictureURL}
            onClose={() => setPictureURL(null)}
          />
        )}
      </>
    );
  }

  return (
    <FileCell
      link={url}
      onClick={() => window.open(url, "_blank", "noopener,noreferrer")}
    />
  );
};

export default UploadCell;
